import React from 'react';
import { Divider, P, Stack } from '@ovotech/element-v5';
import { TopupHistoryItem } from '@/src/api/payg/types';
import {
  TopupCopy,
  TopupCopyAction,
} from '@/src/components/payg/utils/topupCopy';
import { TopupActions } from '@/src/components/payg/TopupActions';
import {
  getTopupDetailCopy,
  joinTitleAndMessage,
} from '@/src/components/payg/utils/topupCopyHelpers';
import { ErrorCode } from './ErrorCode';
import { UtrnCode } from './UtrnCode';

type Props = {
  item: TopupHistoryItem;
};

// TODO: show the contact actions again once they are gated on how old the
// transaction is.
const AGE_GATED_ACTIONS: TopupCopyAction[] = ['webchat', 'call'];

const getDetailActions = ({ buttons }: TopupCopy) =>
  buttons?.filter(action => !AGE_GATED_ACTIONS.includes(action));

export const TopupDetailContent = ({ item }: Props) => {
  if (item.detailedState === 'PROCESSING') {
    return null;
  }

  const copy = getTopupDetailCopy({
    state: item.detailedState,
    isAsc: item.topupType === 'asc',
  });
  const message = joinTitleAndMessage(copy);
  const utrnCode = 'utrn' in item ? <UtrnCode utrn={item.utrn} /> : null;
  const utrnAboveMessage = item.detailedState === 'APPLY_FAILED_CONTACT_US';

  return (
    <Stack spaceBetween={4}>
      <Divider />
      {utrnAboveMessage && utrnCode}
      {message && <P>{message}</P>}
      {!utrnAboveMessage && utrnCode}
      {'error' in item && <ErrorCode error={item.error} />}
      {copy.nextStep && <P>{copy.nextStep}</P>}
      <TopupActions actions={getDetailActions(copy)} />
    </Stack>
  );
};
